export const getSkipLimit = (pageSize = 0, currentPage = 0) => {
    const limit = pageSize;
    const skip = (currentPage - 1) * pageSize;
    return { limit, skip };
}